import styled from 'styled-components';
import { getTextType, mq, getGridSpan, btnReset, getTransition } from '../../../stylesheets/tools';

const StyledVideo = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;

  button {
    ${btnReset}
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;

    @supports (object-fit: cover) {
      height: 100%;
      object-fit: cover;
    }
  }

  .video__frame {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    visibility: hidden;
    opacity: 0;
    ${getTransition('defaultFast')}

    &--visible {
      visibility: visible;
      opacity: 1;
    }

    iframe {
      width: 100%;
      height: 100%;
    }
  }

  .video__frame-in,
  div {
    width: 100%;
    height: 100%;
  }

  .video__playButton {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    ${getTransition('defaultFast')}

    [data-whatinput='mouse'] &,
    [data-whatinput='touch'] & {
      outline: 0;
    }

    .video__icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  &:hover {
    .video__icon {
      opacity: 0.8;
    }
  }

  .video__poster-fallback {
    background-color: ${props => props.theme.siteTheme.secondary};
    position: absolute;
    top: 50%;
    left: 50%;
    min-width: 100%;
    min-height: 100%;
    transform: translate(-50%, -50%);
  }
`;

const StyledVideoSkeleton = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100%;
  padding-bottom: calc(9 / 16 * 100% - 10px);
  border: 3px solid black;
  background: #fff;

  ${mq('m')} {
    border: 5px solid black;
  }

  span {
    position: absolute;
    width: 100%;
    text-transform: uppercase;
    bottom: 0;
    left: 0;
    padding: 30px 30px 40px;
    ${getTextType('subline')}

    ${mq('m')} {
      width: ${getGridSpan(8)};
      ${getTextType('primary')}
    }

    &:before {
      position: absolute;
      content: '';
      width: 50px;
      height: 3px;
      top: 0px;
      left: -25px;
      background: #000;

      ${mq('m')} {
        height: 5px;
      }
    }
  }
`;

export { StyledVideo, StyledVideoSkeleton };
